export default "__VITE_ASSET__f5f80afa__"